import React, { useCallback, useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import DealerDropdown from '../../../../components/common/DealerDropdown';
import { useLanguage } from '../../../../contexts/LanguageContext';

const initialFilters = {
    dealer: null,
    dealerCode: '',
    dealerName: '',
    partCode: ''
};

export default function MaterialCatalogFilters({ onApplyFilters, onResetFilters, canSeeDealerDropdown, isDealer, activeIndex }) {
    const { th } = useLanguage();

    const [filterOpen, setFilterOpen] = useState(true);
    const [filters, setFilters] = useState(initialFilters);
    const [dealerKey, setDealerKey] = useState(0);

    const toggleOpen = useCallback(() => setFilterOpen((p) => !p), []);

    const setField = useCallback((field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    }, []);

    const formatFilters = (f) => {
        const kunnr = f.dealer?.id != null ? String(f.dealer.id) : null;
        const dealerCode = activeIndex === 2 ? (f.dealerCode?.trim() || null) : null;
        const dealerName = activeIndex === 2 ? (f.dealerName?.trim() || null) : null;

        return {
            kunnr,
            dealerCode,
            dealerName,
            partCode: f.partCode?.trim() || null
        };
    };

    const apply = useCallback(() => {
        onApplyFilters?.(formatFilters(filters));
    }, [filters, onApplyFilters, activeIndex]); // eslint-disable-line

    const reset = useCallback(() => {
        setFilters(initialFilters);
        setDealerKey((k) => k + 1);
        onResetFilters?.();
    }, [onResetFilters]);

    const showDealerDropdown = canSeeDealerDropdown;
    const showDealerCodeInput = activeIndex === 2 && isDealer;
    const showDealerNameInput = activeIndex === 2 && isDealer;

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button
                        icon="pi pi-filter"
                        label={th('common.filter')}
                        onClick={toggleOpen}
                        outlined={!filterOpen}
                    />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">
                        {th('materialCatalog.filters.title')}
                    </div>

                    <div className="grid">
                        {showDealerDropdown && (
                            <div className="col-12 md:col-6 lg:col-3">
                                <div className="field">
                                    <label className="block mb-2 text-sm">
                                        {th('common.dealer')}
                                    </label>
                                    <DealerDropdown
                                        key={dealerKey}
                                        value={filters.dealer}
                                        onChange={(val) => setField('dealer', val)}
                                        className="w-full"
                                        multiple={false}
                                        rowCount={100}
                                        placeholder={th('materialCatalog.filters.dealerPlaceholder')}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field">
                                <label className="block mb-2 text-sm">
                                    {th('materialCatalog.partCode')}
                                </label>
                                <InputText
                                    value={filters.partCode ?? ''}
                                    onChange={(e) => setField('partCode', e.target.value)}
                                    className="w-full"
                                    placeholder={th('materialCatalog.filters.partCodePlaceholder')}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3">
                        <Button
                            label={th('materialCatalog.filters.reset')}
                            icon="pi pi-refresh"
                            className="p-button-outlined mr-2"
                            onClick={reset}
                        />
                        <Button
                            label={th('materialCatalog.filters.apply')}
                            icon="pi pi-check"
                            onClick={apply}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}